(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    const MOBILE_BREAKPOINT = 749;
    let initialized = false;
    let resizeTimer;

    function init() {
      const footerContent = document.querySelector('.footer-content[data-footer-accordion="true"]');
      if (!footerContent) return;

      function handleResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (window.innerWidth <= MOBILE_BREAKPOINT) {
            if (!initialized) buildAccordions(footerContent);
          } else {
            if (initialized) teardownAccordions(footerContent);
          }
        }, 150);
      }

      if (window.innerWidth <= MOBILE_BREAKPOINT) {
        buildAccordions(footerContent);
      }

      window.addEventListener('resize', handleResize);
    }

    function buildAccordions(container) {
      if (initialized) return;

      const blocks = container.querySelectorAll(':scope > *');
      const disableString = container.getAttribute('data-disable-accordion-blocks') || '';
      const disabledIndices = disableString.split(',').map(s => parseInt(s.trim()) - 1).filter(n => !isNaN(n));

      blocks.forEach((block, index) => {
        if (disabledIndices.includes(index)) return;

        const heading = block.querySelector(
          '.menu__heading__default, ' +
          'h2[class*="heading"], h3[class*="heading"], ' +
          'h2:first-child, h3:first-child, ' +
          '.group__heading, [class*="__heading"]'
        );

        if (!heading) return;

        let headingText = heading.innerText ? heading.innerText.trim() : heading.textContent.trim();
        headingText = headingText.split('\n')[0].trim();
        if (!headingText) return;

        heading.classList.add('footer-accordion-hidden-heading');

        const nativeDetails = block.querySelectorAll('details');
        nativeDetails.forEach(details => details.setAttribute('open', 'true'));

        block.classList.add('footer-accordion-wrap');
        block.setAttribute('data-accordion-index', index);

        const trigger = document.createElement('button');
        trigger.className = 'footer-accordion-trigger';
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', `footer-accordion-body-${index}`);
        trigger.setAttribute('id', `footer-accordion-trigger-${index}`);
        trigger.innerHTML = `
          <span class="footer-accordion-trigger__text">${headingText}</span>
          <span class="footer-accordion-trigger__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"></polyline></svg>
          </span>
        `;

        const body = document.createElement('div');
        body.className = 'footer-accordion-body';
        body.id = `footer-accordion-body-${index}`;
        body.setAttribute('role', 'region');
        body.setAttribute('aria-labelledby', `footer-accordion-trigger-${index}`);
        body.setAttribute('data-state', 'closed');

        const inner = document.createElement('div');
        inner.className = 'footer-accordion-body__inner';

        Array.from(block.childNodes).forEach(child => inner.appendChild(child));

        body.appendChild(inner);
        block.appendChild(trigger);
        block.appendChild(body);

        trigger.addEventListener('click', () => toggleAccordion(trigger, body));
      });

      initialized = true;
    }

    function toggleAccordion(trigger, body) {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        body.style.height = body.scrollHeight + 'px';
        body.offsetHeight;
        body.style.height = '0px';
        body.setAttribute('data-state', 'closed');
        trigger.setAttribute('aria-expanded', 'false');

        body.addEventListener('transitionend', function handler(e) {
          if (e.propertyName === 'height') body.removeEventListener('transitionend', handler);
        });
      } else {
        const container = trigger.closest('.footer-content');
        if (container) {
          container.querySelectorAll('.footer-accordion-trigger[aria-expanded="true"]').forEach(otherTrigger => {
            if (otherTrigger !== trigger) {
              const otherBody = document.getElementById(otherTrigger.getAttribute('aria-controls'));
              if (otherBody) {
                otherBody.style.height = otherBody.scrollHeight + 'px';
                otherBody.offsetHeight;
                otherBody.style.height = '0px';
                otherBody.setAttribute('data-state', 'closed');
                otherTrigger.setAttribute('aria-expanded', 'false');
              }
            }
          });
        }

        body.setAttribute('data-state', 'open');
        trigger.setAttribute('aria-expanded', 'true');

        const inner = body.querySelector('.footer-accordion-body__inner');
        const targetHeight = inner.scrollHeight;
        body.style.height = '0px';
        body.offsetHeight;
        body.style.height = targetHeight + 'px';

        body.addEventListener('transitionend', function handler(e) {
          if (e.propertyName === 'height') {
            body.style.height = 'auto';
            body.removeEventListener('transitionend', handler);
          }
        });
      }
    }

    function teardownAccordions(container) {
      if (!initialized) return;

      container.querySelectorAll('.footer-accordion-wrap').forEach(block => {
        const trigger = block.querySelector('.footer-accordion-trigger');
        const body = block.querySelector('.footer-accordion-body');
        const inner = body ? body.querySelector('.footer-accordion-body__inner') : null;

        if (inner) {
          Array.from(inner.childNodes).forEach(child => block.appendChild(child));
        }

        const hiddenHeading = block.querySelector('.footer-accordion-hidden-heading');
        if (hiddenHeading) hiddenHeading.classList.remove('footer-accordion-hidden-heading');

        if (trigger) trigger.remove();
        if (body) body.remove();

        block.classList.remove('footer-accordion-wrap');
        block.removeAttribute('data-accordion-index');
      });

      initialized = false;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      requestAnimationFrame(() => requestAnimationFrame(init));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
